<template>
<span>
    <span class="btn"
          v-if="params.trigger_type.button.active == true"
          :class="params.trigger_type.button.cls"
          @click="save" v-html="params.trigger_type.button.html_content">
        {{params.trigger_type.button.content}}
    </span>

    <div type="button" class="close" data-dismiss="alert" aria-label="Close"
         :class="params.trigger_type.close.cls"
         v-if="params.trigger_type.close.active == true"
         @click="save">
                        <span aria-hidden="true"><i class="fa fa-check"></i></span>
    </div>
</span>
</template>

<script>
    import {_} from 'underscore';
    import updateTheme from '../../../js/helpers/theme-manager'

    //ADD JSDOC HERE!!!!!
    export default {
        props: ['content'],
        created() {
        },
        destroyed() {
        },
        mounted() {

            if (typeof this.content !== 'undefined' && this.content !== null) {
                this.trigger_type = this.content.trigger_type;
                this.value = this.content.value;
                this.theme_page = this.content.theme_page;
                this.trigger = this.content.trigger;

                for (let i = 0; i < this.defaultParams.length; ++i) {
                    let key = this.defaultParams[i];

                    if (typeof this.content.params.trigger_type[this.trigger_type][key] !== 'undefined'
                        && this.content.params.trigger_type[this.trigger_type][key] !== null) {

                        this.params.trigger_type[this.trigger_type][key] = this.content.params.trigger_type[this.trigger_type][key];

                    }
                }
            }
        },
        data() {

            return {
                defaultParams: ['active', 'cls', 'html_content', 'content'],
                trigger_type: '',
                theme_page: '',
                trigger: '',
                value: '',
                params: {

                    trigger_type: {
                        button: {
                            action: 'close',
                            active: false,
                            cls: 'btn-primary',
                            html_content: '',
                            content: 'button content',
                        },
                        close: {
                            action: true,
                            active: false,
                            cls: '',
                            html_content: '',
                            content: ''
                        }
                    }
                }
            }
        },
        methods: {
            save() {
                let data = {};
                data[this.trigger] = this.value;
                console.log('saving',data);

                updateTheme({
                    page: this.theme_page,
                    data: data
                })
            }
        },
        computed: {}
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/theme_manager/ThemeManager.vue?de6fc214